import { render, staticRenderFns } from "./TailwindModal.vue?vue&type=template&id=d1662a9c"
import script from "./TailwindModal.vue?vue&type=script&lang=js"
export * from "./TailwindModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports